var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "features-manager"
  }, [_c('table', {
    staticClass: "uk-table uk-table-small uk-table-justify"
  }, [_c('draggable', {
    attrs: {
      "options": {
        handle: '.drag-handle'
      },
      "element": "tbody"
    },
    on: {
      "end": _vm.onInput
    },
    model: {
      value: (_vm.features),
      callback: function($$v) {
        _vm.features = $$v
      },
      expression: "features"
    }
  }, _vm._l((_vm.features), function(feature, index) {
    return _c('tr', {
      staticClass: "features-manager__row"
    }, [_c('td', {
      staticClass: "uk-table-shrink"
    }, [_c('drag-handle', {
      staticClass: "features-manager__drag-handle"
    })], 1), _vm._v(" "), _c('td', {
      staticClass: "uk-width-1-5"
    }, [_c('text-input', {
      ref: "featureName",
      refInFor: true,
      attrs: {
        "disabled": _vm.disabled,
        "errors": _vm.internalErrors[index] && _vm.internalErrors[index].name,
        "label": false,
        "placeholder": _vm.$t('placeholders.name')
      },
      on: {
        "blur": function($event) {
          _vm.removeFeatureWhenEmpty(index)
        },
        "change": function($event) {
          _vm.onInput()
        }
      },
      model: {
        value: (feature.name),
        callback: function($$v) {
          feature.name = $$v
        },
        expression: "feature.name"
      }
    })], 1), _vm._v(" "), _c('td', [_c('textarea-input', {
      ref: "featureValue",
      refInFor: true,
      attrs: {
        "collapse": true,
        "disabled": _vm.disabled,
        "errors": _vm.internalErrors[index] && _vm.internalErrors[index].value,
        "label": false,
        "placeholder": _vm.$t('placeholders.value')
      },
      on: {
        "blur": function($event) {
          _vm.removeFeatureWhenEmpty(index)
        },
        "change": function($event) {
          _vm.onInput()
        }
      },
      model: {
        value: (feature.value),
        callback: function($$v) {
          feature.value = $$v
        },
        expression: "feature.value"
      }
    })], 1), _vm._v(" "), _c('td', {
      staticClass: "uk-table-shrink"
    }, [_c('ul', {
      staticClass: "uk-iconnav data-grid-actions uk-float-right features-manager__actions uk-preserve-width"
    }, [_c('li', [_c('a', {
      attrs: {
        "href": "#",
        "tabindex": "-1"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.maybeRemoveFeature(index)
        }
      }
    }, [_c('icon', {
      attrs: {
        "name": "trash"
      }
    })], 1)])])])])
  })), _vm._v(" "), _c('tfoot', {
    staticClass: "features-manager__footer"
  }, [_c('tr', [(_vm.hasItems) ? _c('td', {
    staticClass: "uk-table-shrink"
  }) : _vm._e(), _vm._v(" "), _c('td', {
    staticClass: "uk-width-1-5"
  }, [_c('text-input', {
    ref: "newFeatureName",
    attrs: {
      "disabled": _vm.disabled,
      "label": false,
      "placeholder": _vm.$t('placeholders.name')
    },
    on: {
      "input": _vm.addFeatureWithName
    },
    model: {
      value: (_vm.newFeature.name),
      callback: function($$v) {
        _vm.newFeature.name = $$v
      },
      expression: "newFeature.name"
    }
  })], 1), _vm._v(" "), _c('td', [_c('textarea-input', {
    attrs: {
      "disabled": _vm.disabled,
      "label": false,
      "placeholder": _vm.$t('placeholders.value')
    },
    on: {
      "input": _vm.addFeatureWithValue
    },
    model: {
      value: (_vm.newFeature.value),
      callback: function($$v) {
        _vm.newFeature.value = $$v
      },
      expression: "newFeature.value"
    }
  })], 1), _vm._v(" "), (_vm.hasItems) ? _c('td', {
    staticClass: "uk-table-shrink"
  }) : _vm._e()])])], 1)])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1a3a8485","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./components/FeaturesManager.vue
// module id = 1879
// module chunks = 0